var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_27994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 12C24.5 5.3719 19.1281 0 12.5 0C5.8719 0 0.5 5.3719 0.5 12C0.5 17.9907 4.8875 22.9547 10.625 23.8547V15.4688H7.5781V12H10.625V9.35625C10.625 6.3492 12.4156 4.6875 15.1578 4.6875C16.4703 4.6875 17.8438 4.92188 17.8438 4.92188V7.875H16.3297C14.8391 7.875 14.375 8.8008 14.375 9.75V12H17.7031L17.1711 15.4688H14.375V23.8547C20.1125 22.9547 24.5 17.9907 24.5 12Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1711 15.4688L17.7031 12H14.375V9.75C14.375 8.8008 14.8391 7.875 16.3297 7.875H17.8438V4.92188C17.8438 4.92188 16.4703 4.6875 15.1578 4.6875C12.4157 4.6875 10.625 6.3492 10.625 9.35625V12H7.57812V15.4688H10.625V23.8547C11.2367 23.9508 11.8625 24 12.5 24C13.1375 24 13.7633 23.9508 14.375 23.8547V15.4688H17.1711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_27994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.7a5af875da7ffcbd84be07969b46958f.svg";
export { ForwardRef as ReactComponent };